import { render } from "./incident-list.vue?vue&type=template&id=623dbc6f&scoped=true"
import script from "./incident-list.vue?vue&type=script&lang=js"
export * from "./incident-list.vue?vue&type=script&lang=js"

import "./incident-list.vue?vue&type=style&index=0&id=623dbc6f&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623dbc6f"]])

export default __exports__